import { render, staticRenderFns } from "./PaymentMethodsModal.vue?vue&type=template&id=4ede01da&scoped=true"
import script from "./PaymentMethodsModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodsModal.vue?vue&type=style&index=0&id=4ede01da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede01da",
  null
  
)

export default component.exports